
import * as React from "react";
import {Api} from "../../../../lib/Api";

interface IAcceptButtonProps {
    order: any
    setUrl: any

}

interface IAcceptButtonState {
}

export default class AcceptButton extends React.Component<IAcceptButtonProps, IAcceptButtonState>{

    constructor(props:IAcceptButtonProps){
        super(props);
        this.state = {

        };

    }

    private acceptOrder(){
        Api.call('/user/order/acceptOrder', {
            orderId: this.props.order.id
        }, (result) =>{
            this.props.setUrl('/user/index');
        });
    }


    render() {

        const statuses = ['modify_hour', 'waiting_photo_request'];
        let order = this.props.order;

        if(!statuses.includes(order.status.key)){
            return (<></>);
        }

        return (
            <div className = "row">
                <div className = "col-md-12">
                    <button className="green_btn" onClick={() => this.acceptOrder()}>I accept</button>
                </div>
            </div>
        );


    }
}
